import React, {useEffect, useState} from "react";
import {Button} from "primereact/button";
import EntityForm from "./components/EntityForm";
import Toggle from "./components/Toogle";
import DeleteConfirmDialog from "./components/DeleteConfirmDialog";
import {Panel} from "primereact/panel";
import {Divider} from "primereact/divider";
import Asset from "./Asset";
import GeneralUtils from "../../../../utils/GeneralUtils";
import {LectureService} from "../../../../service/LectureService";

const defaultData = [{title: "Giriş", description: null, objectIndex: 1}];

// EntityForm için ortak props
const LECTURE_FORM_PROPS = {
    entityName: "Ders",
    titlePlaceholder: "Başlık Girin",
    descriptionLabel: "Ders Açıklaması",
    descriptionPlaceholder: "Bir açıklama ekleyin. Öğrencilerin bu dersi bitirdikten sonra neler yapabileceğini içerebilir."
};

const Lecture = (props) => {
    const {course, chapter, setChapter} = props;
    const [data, setData] = useState(chapter.lectureList ? chapter.lectureList : []);
    const [activeIndex, setActiveIndex] = useState();
    const [toggleForm, setToggleForm] = useState(false);
    const [lectureToDelete, setLectureToDelete] = useState(null);
    const service = new LectureService();

    useEffect(() => {
        setChapter(data);
    }, [data]);

    const addLecture = (lecture) => {
        lecture.chapter = chapter.id;
        lecture.objectIndex = data.length + 1;
        service.create(lecture).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && GeneralUtils.isNullOrEmpty(response.error)) {
                response.chapter = response.chapter?.id;
                setData([...data, response]);
                setToggleForm(!toggleForm);
                // setChapter([...data, {title: title}]);
            }
        });
    }

    const updateLecture = (lecture) => {
        const {asset, ...lectureToUpdate} = lecture; // asset'i ayır
        lectureToUpdate.chapter = chapter.id;
        service.update(lectureToUpdate).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && GeneralUtils.isNullOrEmpty(response.error)) {
                data[lecture.objectIndex-1] = {...lecture, ...response};
                setData([...data]);
                setActiveIndex(-1);
                // setChapter(data);
            }
        });
    };

    const deleteLecture = (id) => {
        service.delete(id).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && GeneralUtils.isNullOrEmpty(response.error)) {
                setData((prevData) => prevData.filter((lecture,i)=> lecture.id !== id));
                // setChapter(data.filter((chapter,i)=> i !== index));
                // toast.success('Kayıt Başarıyla Silindi');
            }
        });
    };


    const renderView = (lecture, index, options) => {
        const toggleIcon = lecture.asset
            ? (options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up')
            : (options.collapsed ? 'pi pi-plus' : 'pi pi-minus');
        const borderColor = lecture.asset ? "" : "border-danger";
        const className = `${options.className} justify-content-start`;

        return (
            <div className={className + " flex flex-row align-items-center bg-white w-full gap-3 px-2 py-1 " + borderColor}>
                <div className="flex flex-row align-items-center gap-2 flex-1 min-w-0">
                    {/*<i className="pi pi-file p-disabled"/>*/}
                    <p className="m-0" style={{minWidth: "50px", fontWeight: 600}}>Ders {lecture.objectIndex}:</p>
                    <p className="m-0 text-overflow-ellipsis overflow-hidden white-space-nowrap flex-1"
                       title={lecture.title}>{lecture.title}</p>
                </div>


                <div className="flex flex-row align-items-center gap-2 flex-shrink-0">
                    {/*<Button icon='pi pi-plus' label="İçerik Ekle" severity="secondary" outlined size="small"*/}
                    {/*        className="button-white" onClick={(e) => console.log("İçerik Ekle")}/>*/}


                    {(index === data.length - 1) && <Button icon="pi pi-fw pi-trash" rounded text severity="danger"
                                                            onClick={() => setLectureToDelete(lecture)}/>}

                    <Button icon="pi pi-fw pi-pencil" rounded text severity="secondary"
                            onClick={() => setActiveIndex(index)}/>

                    <Button icon={toggleIcon} severity="secondary" rounded text onClick={options.onTogglerClick}
                            size="small"/>
                    {/*<Button icon="pi pi-fw pi-chevron-down" rounded text severity="secondary"/>*/}
                </div>
            </div>
        );
    };


    const renderEdit = (lecture, index) => (
        <div className="pl-4 pr-4 pt-2 pb-2">
            <EntityForm
                {...LECTURE_FORM_PROPS}
                index={index}
                data={lecture}
                cancel={() => setActiveIndex(-1)}
                save={(lecture) => updateLecture(lecture)}
            />
        </div>
    );

    const renderTitle = (lecture, index, options) => (
        index !== activeIndex
            ? renderView(lecture, index, options)
            : renderEdit(lecture, index)
    );


    return (<div className=" ml-5">{data?.sort(GeneralUtils.compareIndex).map((lecture, index) => (
            <Panel key={index} toggleable collapsed={true} headerTemplate={options => renderTitle(lecture, index, options)}
                   className="lecture-editor noshadow mb-3 mt-3">
                <div className="flex flex-column gap-2">
                    {lecture.description &&
                        <div>
                            <p><span style={{minWidth: "50px", fontWeight: "600"}}>Ders Açıklaması: </span>{lecture.description}</p>
                            <Divider/>
                        </div>}

                    <Asset course={course} lecture={lecture} setLecture={asset => {data[index] = {...data[index], asset: asset}; setData(data)}}/>
                </div>
            </Panel>
        ))}

            <Toggle
                label="Ders Ekle"
                visible={toggleForm}
                onHide={() => setToggleForm(!toggleForm)}
                showCard={true}
                cardClassName="lecture-form noshadow"
            >
                <EntityForm
                    {...LECTURE_FORM_PROPS}
                    index={data.length}
                    cancel={() => setToggleForm(!toggleForm)}
                    save={(lecture) => addLecture(lecture)}
                />
            </Toggle>


            <DeleteConfirmDialog
                itemToDelete={lectureToDelete}
                onHide={() => setLectureToDelete(null)}
                onConfirm={deleteLecture}
            />
        </div>
    )
};

export default Lecture;
